import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'

export default function ForbiddenPage() {
  return (
    <div className="min-h-screen bg-[#0b130e] text-[#f1f5f2] flex flex-col selection:bg-emerald-800 selection:text-emerald-100">
      <Header />
      <main className="flex-grow flex items-center justify-center py-28 px-4 sm:px-6 lg:px-8">
        <div className="max-w-xl w-full text-center bg-[#0e1c14] border border-[#1b3624] rounded-3xl p-8 sm:p-12 shadow-2xl relative overflow-hidden">
          <div
            className="pointer-events-none absolute -top-20 -right-20 w-60 h-60 rounded-full bg-emerald-600/10 blur-3xl"
            aria-hidden="true"
          />

          <div className="w-16 h-16 rounded-2xl bg-[#14281c] border border-amber-500/30 text-amber-400 flex items-center justify-center text-2xl mx-auto mb-6">
            <i className="fa-solid fa-shield-halved text-2xl" aria-hidden="true" />
          </div>

          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-950/60 border border-amber-800/50 text-xs font-semibold text-amber-300 mb-4">
            <span>Error 403 · Access Forbidden</span>
          </div>

          <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
            Access Restricted
          </h1>

          <p className="mt-4 text-sm sm:text-base text-neutral-300 leading-relaxed">
            You do not have permission to access the requested resource. If you believe this is in error, please reach out to company management.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-semibold text-xs sm:text-sm text-neutral-950 bg-emerald-400 hover:bg-emerald-300 transition-colors shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400"
            >
              <i className="fa-solid fa-arrow-left text-xs" aria-hidden="true" />
              <span>Return to Homepage</span>
            </Link>

            <a
              href="mailto:tab@biofuelglobal.dk"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-semibold text-xs sm:text-sm text-white bg-[#14291c] hover:bg-[#1b3826] border border-[#234b33] transition-colors whitespace-nowrap"
            >
              <i className="fa-solid fa-envelope text-emerald-400 text-xs" aria-hidden="true" />
              <span>Contact Management</span>
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}
